// Each bound value back out to its control, polled: a binding sends only when its messages change, never while its control is moving (echo).
import { parseTarget } from './model'
import { fromDomain } from './shape'

export const FEEDBACK_MS = 33
export const FEEDBACK_BUDGET = 32

/**
 * @param readTarget  parsed target → `{ schema, value }` or null
 * @param busy        binding id → whether its control moved just now
 * @param encode      (binding, position) → messages, or null
 * @param send        (binding, messages) → whether they went out
 */
export const createFeedback = ({ readTarget, busy, encode, send }) => {
	let list = []
	let cursor = 0
	// binding id → the messages last sent, as a string
	const sent = new Map()

	const setBindings = bindings => {
		list = (bindings ?? []).filter(b => b?.enabled && b.targets?.length)
		const ids = new Set(list.map(b => b.id))
		for (const id of sent.keys()) if (!ids.has(id)) sent.delete(id)
		cursor = 0
	}

	const tick = () => {
		const n = list.length
		let budget = FEEDBACK_BUDGET
		let k = 0
		for (; k < n && budget > 0; k++) {
			const b = list[(cursor + k) % n]
			if (busy(b.id)) continue
			const t = b.targets[0]
			const now = readTarget(parseTarget(t.target))
			if (!now) continue
			const msgs = encode(b, fromDomain(now.value, now.schema, t))
			if (!msgs) continue
			const key = String(msgs)
			if (sent.get(b.id) === key) continue
			if (send(b, msgs)) {
				sent.set(b.id, key)
				budget--
			}
		}
		cursor = n ? (cursor + k) % n : 0
	}

	return { setBindings, tick, invalidate: () => sent.clear() }
}
